import { zapiPlayOptions } from './utils';
import { errorPlayerContainerNotCreated } from './errors';
export const playerPlayVodTrailer = (container, parameters) => {
    if (!container) {
        throw errorPlayerContainerNotCreated;
    }
    const player = container.getPlayerZapi();
    return player.playVodTrailer({
        teasableId: parameters.teasableId,
        // @ts-expect-error defined as string
        teasableType: parameters.teasableType,
        playOptions: zapiPlayOptions(parameters.options),
    });
};
